import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AdminLogin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = async () => {
    await axios
      .post("/api/admin/login", {
        email: email,
        password: password,
      })
      .then((res) => {
        if (res.data.result === "0000") {
          console.log(res.data);
          sessionStorage.setItem("id", res.data.id);
          sessionStorage.setItem("email", res.data.email);
          sessionStorage.setItem("name", res.data.name);
          toast.success(`${res.data.name}님 환영합니다.`, {
            onClose: () => (window.location.href = "/admin/dashboard"),
          });
        } else {
          toast.error(res.data.message, {
            onClose: () => (window.location.href = "/"),
          });
        }
      })
      .catch((e) =>
        toast.error(e, {
          onClose: () => (window.location.href = "/"),
        })
      );
  };
  return (
    <div className=" relative w-full h-full min-h-screen px-[calc((100%-var(--container))/2)] bg-slate-50 py-14 lg:py-28">
      <div className=" relative w-full h-full mx-auto rounded-2xl py-20  px-2 lg:px-5">
        <div className="relative w-full h-fit max-w-52 xl:max-w-64 mx-auto mb-10 ">
          <img
            alt="logo"
            onClick={() => navigate("/")}
            className="!relative w-auto h-full max-h-16 xl:max-h-20 py-3 object-contain cursor-pointer"
            src="/images/logo.png"
            width={429}
            height={153}
          />
        </div>
        <div className=" relative w-full login-container h-fit grid grid-rows-2 gap-5">
          <input
            type="text"
            name="id"
            id="id"
            placeholder="아이디"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            name="password"
            id="password"
            placeholder="비밀번호"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="relative w-full h-fit mx-auto mt-8 login-container">
          <button
            type="button"
            onClick={login}
            className=" relative w-full h-fit py-3 bg-point text-white rounded-md"
          >
            <p className="font-black">관리자 로그인</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
